import { ConfigurationTemplate } from '../wizard-model.interface';
import { Injectable } from '@angular/core';
import { ControlCabinetModel } from './control-cabinet.model';

@Injectable()
export class IekConfigurationModel extends ControlCabinetModel {
  public get type() {
    return 'IEK_CONFIGURATION';
  }

  constructor() {
    super();
  }

  protected createConfig(): ConfigurationTemplate {
    return {
      id: 'reate-project-iek-configuration',
      type: 'type',
      imageUrl: "ng-assets/img/projecttypes/iek.webp",
      label: 'configurationCreation.type.iek_configuration',
      steps: [
        {
          type: 'meta',
          id: 'meta',
          label: 'configurationCreation.progress.configuration_data',
        },
        {
          type: 'iekConfiguration',
          id: 'mounting',
          label: 'configurationCreation.progress.mounting_rail',
        }
      ]
    }
  }
}
